import {
    DELETE_ADDRESS,
    GET_ADDRESSES,
    SAVE_ADDRESS,
    SET_DEFAULT
} from "./actionTypes";
import {
    DELETE_ADDRESS_URL,
    GET_ADDRESSES_URL,
    SAVE_ADDRESS_URL,
    SET_DEFAULT_URL, keyValue
} from "../../configs";

import Axios from "axios";

export const getAddresses = (user_id ) => dispatch => {
	Axios.defaults.headers.common = {
          "X-API-Key": keyValue,
        };
    Axios.post(GET_ADDRESSES_URL, {
        user_id: user_id,
    })
        .then(response => {
            const addresses = response.data;
            return dispatch({
                type: GET_ADDRESSES,
                payload: addresses
            });
        })
        .catch(function(error) {
            console.log(error);
        });
};

export const saveAddress = (
    user_id,
    firstname,
    phone_no,
    email_id,
    address,
    address2,
    city,
    state,
    zipcode,
    country
) => dispatch => {
	Axios.defaults.headers.common = {
          "X-API-Key": keyValue,
        };
    Axios.post(SAVE_ADDRESS_URL, {
        user_id : user_id,
		firstname : firstname,
		phone_no : phone_no,
		email_id : email_id,
		birthdate : '',
		gender : '',
		address_line1 : address,
		address_line2 : address2,
		city : city,
		state : state,
		zipcode : zipcode,
		country : country,
    })
        .then(response => {
            const addresses = response.data;
            return dispatch({
                type: SAVE_ADDRESS,
                payload: addresses
            });
        })
        .catch(function(error) {
            console.log(error);
        });
};

export const deleteAddress = (user_id, address_id, token) => dispatch => {
    Axios.post(DELETE_ADDRESS_URL, {
        token: token,
        user_id: user_id,
        address_id: address_id
    })
        .then(response => {
            const addresses = response.data;
            return dispatch({
                type: DELETE_ADDRESS,
                payload: addresses
            });
        })
        .catch(function(error) {
            console.log(error);
        });
};

export const setDefaultAddress = (user_id, address_id, token) => dispatch => {
    return Axios.post(SET_DEFAULT_URL, {
        token: token,
        user_id: user_id,
        address_id: address_id
    })
        .then(response => {
            const addresses = response.data;
            return dispatch({
                type: SET_DEFAULT,
                payload: addresses
            });
        })
        .catch(function(error) {
            console.log(error);
        });
};
